import styled from "styled-components";
export const ResultItemsContainer = styled.div`
  max-height: 300px;
  overflow: auto;
`;
